import React, { memo, useCallback } from 'react';
import clsx from 'clsx';

export interface InputTabOption {
  value: string;
  label: string;
}

interface InputTabProps {
  defaultValue?: string;
  options: readonly InputTabOption[];
  disabled?: boolean;
  onChange: (value: string) => void;
}

const InputTab: React.FC<InputTabProps> = ({
  defaultValue,
  options,
  disabled = false,
  onChange,
}) => {
  const handleClick = useCallback(
    (value: string) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <div className='flex gap-x-2 py-4'>
      {options.map((option) => (
        <button
          key={option.value}
          type='button'
          onClick={() => handleClick(option.value)}
          disabled={disabled}
          className={clsx(
            'w-fit rounded-sm px-4 py-2 duration-200',
            option.value === defaultValue
              ? 'bg-primary text-white'
              : 'bg-[#F8FBFF] hover:bg-[#ebf2fa]',
            disabled && 'opacity-60'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default memo(InputTab);
